<template>
  <div id='problem'>
    <h2>Largest Exponential</h2>
    <a href="https://projecteuler.net/problem=99">https://projecteuler.net/problem=99</a>
    <h3>Thoughts</h3>
    <p>
      <katex-span expr="\log(a^b) = b*\log(a)" />
    </p>
  </div>
</template>

<script>

export default {
  name: 'P099Page',
  components: {},
}

</script>

<style scoped>
div#problem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-flow: column;
  text-align: left;
  font-size: 1.5rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}
</style>
